import {ApolloClient, ApolloLink, CombinedGraphQLErrors, HttpLink, InMemoryCache, ServerError} from '@apollo/client';
import {SetContextLink} from '@apollo/client/link/context';
import {ErrorLink} from '@apollo/client/link/error';
import {message} from 'antd';

import {getApiBase} from '../../env';
import {IRootStoreModel} from '../store/RootStore';

const API_BASE = getApiBase();

declare module '@apollo/client' {
    export namespace ApolloClient {
        export namespace DeclareDefaultOptions {
            interface WatchQuery {
                errorPolicy: 'ignore'
            }
            interface Query {
                errorPolicy: 'all'
            }
        }
    }
}

const ApiClientFactory = (store: IRootStoreModel) => {

    const errorLink = new ErrorLink(({error, operation}) => {
        const {response} = operation.getContext();
        if ((ServerError.is(error) && error.statusCode === 401) || response?.status === 401) {
            // Если токен сдох, то разлогиниваем пользователя
            store.auth.clearState();
        }

        message.error(error.message).then();

        if (CombinedGraphQLErrors.is(error)) {
            error.errors.forEach((graphQLError) =>
                console.log(`[GraphQL error]: Message: ${graphQLError.message}, Location: ${graphQLError.locations}, Path: ${graphQLError.path}`,)
            );
        } else {
            console.log(`[Network error]: ${error}`);
        }
    });

    const authLink = new SetContextLink(({headers}) => {
        const token = store.auth.token;
        if (!token) {
            return {headers};
        }

        return {
            headers: {
                ...headers,
                authorization: `Bearer ${token}`,
            },
        };
    });

    const httpLink = new HttpLink({
        uri: `${API_BASE}/graphql`,
    });

    return new ApolloClient({
        link: ApolloLink.from([errorLink, authLink, httpLink]),
        cache: new InMemoryCache(),
        defaultOptions: {
            watchQuery: {
                fetchPolicy: 'no-cache',
                errorPolicy: 'ignore',
            },
            query: {
                fetchPolicy: 'no-cache',
                errorPolicy: 'all',
            },
        }
    });
};

export default ApiClientFactory;
